import JourneyContext from './journeys/context/JourneyContext'
import ErrorBoundary from "./ErrorBoundary";
import Journey from './journeys/journey/Journey';
import * as bol from './journeys/journey/bol.json';
import RootContext from './providers/RootProvider';
// import Amplify from 'aws-amplify';
// import awsconfig from './aws-exports';
import './App.scss'
// Amplify.configure(awsconfig)

function App() {
  //Adding one more provider(RootContext) to deal with app state as per standard ..later need to make one provider for app
  return (
    <JourneyContext>
      <RootContext>
        <ErrorBoundary>
          <Journey path="" goal={bol.goal} pages={bol.pages} />
        </ErrorBoundary>
      </RootContext>
    </JourneyContext>
  );
}

export default App;
